// Discord message model types - converted from Go backend models

import type { DiscordMessageID } from '@/models/ids';
import type { RFC3339, Timestamps } from '@/models/base-types';

export const DiscordMessageStatus = {
    WAITING: 'WAITING',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED'
} as const;

export type DiscordMessageStatus = typeof DiscordMessageStatus[keyof typeof DiscordMessageStatus];

export interface DiscordMessage extends Timestamps {
    id: DiscordMessageID;

    channelID: string;
    content: string;

    status: DiscordMessageStatus;
    lastError: string | null;
    sentAt: RFC3339 | null;

    created: RFC3339;
    updated: RFC3339 | null;
    deleted: RFC3339 | null;
}

// List request/response types
export interface ListDiscordMessagesOptions {
    status?: DiscordMessageStatus;
    channelId?: string;
    next?: string;
    limit?: number;
}

export interface ListDiscordMessagesResponse {
    messages: DiscordMessage[];
    next: string;
    total: number;
}

// Request bodies
export interface SendDiscordMessageRequest {
    channelId: string;
    content: string;
}